import { useEffect, useState } from "react";
import { fetchBlobUrl } from "@/lib/api";
import { FileText } from "lucide-react";

export function AuthImage({ path, alt, className }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    let created = null;
    fetchBlobUrl(path)
      .then((u) => { if (active) { created = u; setUrl(u); } })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (created) URL.revokeObjectURL(created);
    };
  }, [path]);

  if (err)
    return (
      <div className={`flex items-center justify-center bg-surface text-muted-foreground ${className}`}>
        <FileText className="h-8 w-8" />
      </div>
    );
  if (!url)
    return <div className={`bg-surface animate-pulse ${className}`} />;
  return <img src={url} alt={alt} className={className} data-testid="auth-image" />;
}
